import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

interface IProtectedRoute {
	component: JSX.Element;
}

const ProtectedRoute = ({ component }: IProtectedRoute) => {
	const token = useSelector((state: any) => state.auth.token);
	const isLoggedIn = !!token;
	if (!isLoggedIn) {
		return <Navigate to={"/login"} replace />;
	}
	return component;
};

export default ProtectedRoute;
